import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ActivityClassificationService } from '../../services/activity-classification.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-read-activity-classification',
  templateUrl: './read-activity-classification.component.html',
  styleUrls: ['./read-activity-classification.component.css']
})
export class ReadActivityClassificationComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  activityClassifications: any[];

  activityClassSub: Subscription;

	// *************** Table configuration *************** //
  data: Array<any>;
  rows: Array<any> = [];
  columns: Array<any> = [
    { title: 'Nombre', name: 'name', sort: 'desc' },
    { title: 'Descripción', name: 'description' },
    { title: 'Por sección', name: 'perSection' },
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
        styleClass: 'btn-floating btn waves-effect light-green darken-1' },
      { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
        styleClass: 'btn-floating btn waves-effect red darken-2', }
    ] } }
  ];

  page = 1;
  itemsPerPage = 20;
  maxSize = 5;
  numPages = 1;
  length = 0;
  config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    api: {
      onEdit: this.onEdit.bind(this),
      onDelete: this.onDelete.bind(this)
    }
  };

  constructor(
    private service: ActivityClassificationService,
		private permissionService: PermissionService,
		private authService: AuthService,
    private router: Router
  ) {
		let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
				permissionsSubs.unsubscribe();
				this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
				if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
				else this.allowed = true;
		});

     this.activityClassSub = this.service.getActivityClassifications().subscribe(tempActivityClass => {
			this.activityClassifications = [];

			for (const idx in tempActivityClass) {
				if(tempActivityClass[idx].perSection){
					tempActivityClass[idx].perSection = '<i class="material-icons">check</i>';
				} else {
					tempActivityClass[idx].perSection = '<i class="material-icons">close</i>';
				}
				this.activityClassifications.push(tempActivityClass[idx]);
			}

			if(localStorage.re_actClas__page){
				this.page = +localStorage.re_actClas__page;
			}
			this.data = this.activityClassifications;
			this.length = this.data.length;
			this.onChangeTable(this.config);
		});
  }

  ngOnInit() {
	}
	ngOnDestroy(){
		this.activityClassSub.unsubscribe();
	}

  onCellClick(data: any) {
  }

	onCreate(){
		if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
		this.router.navigate(['/add_activity_class']);
	}
  onEdit(data: any) {
		if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    this.router.navigate(['/edt_activity_class/' + data.row.id$]);
  }
  onDelete(data: any) {
		if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    this.service.delActivityClassification(data.row.id$);
  }

	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		localStorage.re_actClas__page = `${page.page}`;
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
				Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
				Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}